import { useState } from "react";
import { Download, Clock } from "lucide-react";
import { abs } from "../lib/api";
import { AudioPlayer } from "./AudioPlayer";

function StreamVideo({ src, testid }) {
  const [failed, setFailed] = useState(false);
  return (
    <div className="relative">
      <video controls playsInline preload="metadata" className="w-full bg-black" src={src} onError={() => setFailed(true)} data-testid={`${testid}-video`} />
      {failed && <p role="alert" className="mt-2 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-[#E07A6B]" data-testid={`${testid}-error`}>Video couldn't play. Refresh the page to renew your streaming link.</p>}
    </div>
  );
}

export const MediaStream = ({ item, testid }) =>
  item.type === "audio" ? (
    <AudioPlayer src={abs(item.stream_url)} label="Full track" testid={testid} />
  ) : (
    <StreamVideo src={abs(item.stream_url)} testid={testid} />
  );

export const DigitalDelivery = ({ items, onRegenerate, regenerating }) => {
  const anyExpired = items.some((i) => !i.download_url);
  return (
    <div className="space-y-6" data-testid="digital-delivery">
      {items.map((it) => (
        <div key={it.product_id} className="wb-card p-6" data-testid={`delivery-item-${it.product_id}`}>
          <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
            {it.image_url && <img src={abs(it.image_url)} alt="" className="h-20 w-20 object-cover" />}
            <div className="flex-1">
              <div className="eyebrow">{it.type.replace("_", " ")}</div>
              <div className="font-display text-2xl mt-1">{it.title}</div>
              {it.expires_at && (
                <div className="mt-1 flex items-center gap-1.5 text-xs muted font-mono"><Clock size={12} /> Link expires {new Date(it.expires_at).toLocaleString()}</div>
              )}
            </div>
            {it.download_url ? (
              <a href={abs(it.download_url)} className="btn-gold" data-testid="download-digital-link"><Download size={14} /> Download</a>
            ) : (
              <span className="text-xs font-mono muted" data-testid="download-expired-label">Link expired</span>
            )}
          </div>
          {it.stream_url && <div className="mt-6"><MediaStream item={it} testid={`stream-${it.type}`} /></div>}
        </div>
      ))}
      {onRegenerate && (
        <button onClick={onRegenerate} disabled={regenerating} className="btn-ghost" data-testid="regenerate-links-button">
          {regenerating ? "Sending…" : anyExpired ? "Regenerate expired links & email me" : "Re-send download links by email"}
        </button>
      )}
    </div>
  );
};
